import { render, staticRenderFns } from "./PaymentRequestTabSelfies.vue?vue&type=template&id=4f601ffc"
import script from "./PaymentRequestTabSelfies.vue?vue&type=script&lang=js"
export * from "./PaymentRequestTabSelfies.vue?vue&type=script&lang=js"
import style0 from "./PaymentRequestTabSelfies.vue?vue&type=style&index=0&id=4f601ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports